namespace GeniuzPOS.ReportMasterData {
    export interface Report_1337Form {
    }

    export class Report_1337Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1337';
    }
}
